// Voici le code pour animer la nav
const nav = document.querySelector(".nav-bar");
const navPanel = document.querySelector(".nav-panel");
const contactLink = document.querySelector(".nav-panel ul li:nth-of-type(3)");
const navIconBurger = document.querySelector(".nav-icon-burger");
// On crée une variable avec la dernière position de scroll
let lastScrollPosition = 0;

// lorsqu'on scroll, la var currentScrollPosition est égal à notre valeur de scroll Y dans la fenetre
window.addEventListener("scroll", () => {
  let currentScrollPosition = window.scrollY;

  // Si currentScrollPosition est plus grand que lastScrollPosition, on  met la classe "scrolling-down" a header qui le cache dans le overflow. Sinon, on lui enleve la classe et il réapparait
  if (
    currentScrollPosition > lastScrollPosition &&
    currentScrollPosition > 100 &&
    !navPanel.classList.contains("nav-panel-shown")
  ) {
    nav.classList.add("nav-scrolling-down");
  } else {
    nav.classList.remove("nav-scrolling-down");
  }
  // On assigne la valeur de currentScrollPosition a lastScrollPosition
  lastScrollPosition = currentScrollPosition;
});

contactLink.addEventListener("click", function () {
  nav.classList.add("nav-scrolling-down");
  navPanel.classList.remove("nav-panel-shown");
  navIconBurger.classList.remove("nav-icon-burger-opened");
});

// cela permet d'avoir une nav qui n'est pas présente lorsque l'on scroll vers le bas
